import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

import * as Projects from '../../shared/projects.model';
import { ProjectsService } from '../../services/projects.service';
import { AuthService } from '../../services/auth.service';
import { LanguageService } from '../../services/language.service';
import { RouterUrls } from '../../shared/router-urls';
import {
  SubscriptionDialogComponent
} from '../../your-impact-module/your-impact/subscription-dialog/subscription-dialog.component';
import { ProjectsConstants } from '../projects.constants';
import { switchMap } from 'rxjs/operators';
import { first } from 'rxjs';
import { HeaderService } from '../../services/header.service';

@Component({
  selector: 'app-vote-dialog',
  templateUrl: './vote-dialog.component.html',
  styleUrls: ['./vote-dialog.component.scss']
})
export class VoteDialogComponent implements OnInit {

  RouterUrls = RouterUrls;

  projectInfo: Projects.FullProject;
  votesLeft: number;
  isPledge = false;
  stopSupporting = false;
  stopSupportingConfirmed = false;
  companyName: string;
  isVoted = false;
  isSubscription = false;

  constructor(private dialogRef: MatDialogRef<VoteDialogComponent>,
              @Inject(MAT_DIALOG_DATA) data,
              private projectsService: ProjectsService,
              private authService: AuthService,
              private languageService: LanguageService,
              private headerService: HeaderService,
              private dialog: MatDialog,
              private router: Router) {
    this.projectInfo = data.project;
    this.stopSupporting = data.stopSupporting;
    this.isPledge = data.isPledge;
  }

  ngOnInit(): void {
    this.projectsService.getVotesLeft().subscribe(value => this.votesLeft = value);
    this.projectsService.getClockInfo().subscribe(data => {
      if (data){
        this.companyName = data.company_name;
      }
    });
    this.isVoted = this.projectsService.isVoted(this.projectInfo?.id);
    this.authService.hasSubscription().subscribe(subscriptionValue => {
      if (subscriptionValue){
        this.isSubscription = subscriptionValue;
      }
    });
  }

  closeDialog(parameter?) {
    this.dialogRef.close(parameter);
  }

  get backgroundImageWithGradient() {
    return {backgroundImage: `linear-gradient(0deg, rgba(15,70,84,1) 0%, rgba(15,70,84,0) 45%, rgba(15,70,84,0) 100%),
     url(${this.projectInfo?.picture_cover ? this.projectInfo.picture_cover : this.projectInfo.picture_thumbnail})`};
  }

  voteProject(projectId) {
    this.projectsService.voteProject(projectId).pipe(
      // Check the boolean that indicates if we are showing the first vote onboarding modal, just once
      switchMap(() => this.headerService.$isFirstVoteOnboardingDone.asObservable().pipe(first())),
    ).subscribe({
      next: (isFirstVote) => {
        if (!isFirstVote) {
          if (this.isPledge) {
            // Check if there are votes left after this one, then show success modals
            this.votesLeft - 1 > 0 ?
              this.closeDialog(ProjectsConstants.VOTE_CONFIRMATION) :
              this.closeDialog(ProjectsConstants.FIVE_VOTES_COMPLETED);
          } else {
            // No pledge, does not show success modals
            this.closeDialog();
          }
        }
        // UX LOGIC: We are in the onboarding process, we don't open success modals
        this.closeDialog();
      },
      error: () => {
        // Close dialog in case of an error
        this.closeDialog();
      }
    });
  }

  unvoteProject(projectId) {
    this.projectsService.unvoteProject(projectId).subscribe(
      () => {
        this.stopSupportingConfirmed = true;
        this.stopSupporting = false;
      }
    );
  }

  get currentLang() {
    return this.languageService.getCurrentLangWithSlash();
  }

  get currentLanguage() {
    return this.languageService.getUserUsedLanguage();
  }

  navigateToBrowseProjects() {
    this.router.navigate([this.currentLang, RouterUrls.BrowseProjects]);
    this.closeDialog();
  }

  openOneTimeDonation() {
    const subscriptiondialogConfig = new MatDialogConfig();
    let oneTimeDonation = true;
    if (!this.isSubscription){
      oneTimeDonation = false;
    }
    subscriptiondialogConfig.width = '953px';
    subscriptiondialogConfig.disableClose = true;
    subscriptiondialogConfig.panelClass = 'subscription-dialog';
    subscriptiondialogConfig.maxWidth = '953px';
    subscriptiondialogConfig.closeOnNavigation = true;
    subscriptiondialogConfig.backdropClass = 'backdropBackground';
    subscriptiondialogConfig.data = {
      oneTimeDonation,
      projectId: this.projectInfo.id
    };
    this.dialog.open(SubscriptionDialogComponent, subscriptiondialogConfig);
  }

  reclaimVote() {
    this.closeDialog(ProjectsConstants.RECLAIM_VOTE);
  }

  get rootShare() {
    return RouterUrls.BrowseProjects;
  }
}
